import AddAttachmentDataProviderResponse from 'owa-service/lib/contract/AddAttachmentDataProviderResponse';
import AddableFileProviderInfo from '../utils/AddableFileProviderInfo';
import AttachmentDataProvider from 'owa-service/lib/contract/AttachmentDataProvider';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import addFileProviderService from '../services/addFileProvider';
import datapoints from '../datapoints';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { getAuthWindowInfo } from './helpers/AuthWindowInfo';
import { parse } from 'querystring';

/**
 * In adding provider we do the following
 * 1- Validate the CSRF token
 * 2- Get the OAuth token and add the provider
 * 3- Create and return the provider view state of the newly created provider
 */
// Exported only for testing
// FPAddDataProvider has customData that is called on the addFileProviderToUserAccount input parameters.
// If you change the input params make sure to update FPAddDataProvider in datapoints.ts to match.
export default createLegacyActionWithDatapoint(
    'addFileProviderToUserAccount',
    datapoints.FPAddDataProvider
)(async function addFileProviderToUserAccount(
    redirectUrl: string,
    providerType: AttachmentDataProviderType,
    getAddableFileProviderInfoFunc: (
        providerType: AttachmentDataProviderType
    ) => AddableFileProviderInfo
): Promise<AttachmentDataProvider> {
    const queryStringStartIndex = redirectUrl.indexOf('?');
    const queryString =
        queryStringStartIndex !== -1 ? redirectUrl.slice(queryStringStartIndex + 1) : '';
    const queryStringValues = parse(queryString);

    const { getCSRFToken, getOAuthCode } = getAddableFileProviderInfoFunc(providerType);

    // Validate CSRF token that we received
    const csrfTokenReceived = getCSRFToken(queryStringValues);
    const authWindowInfo = getAuthWindowInfo(providerType).info;
    if (csrfTokenReceived !== authWindowInfo.csrfToken) {
        throw new Error('Invalid CSRF token');
    }

    // Get the OAuth code
    const oAuthCode = getOAuthCode(queryStringValues);
    if (!oAuthCode) {
        throw new Error('OAuth code not found');
    }

    const response: AddAttachmentDataProviderResponse = await addFileProviderService(
        providerType,
        oAuthCode,
        authWindowInfo.redirectUrl,
        authWindowInfo.updateProvider
    );
    return response.NewProvider;
});
